import { createContext, useState } from 'react';
import { deleteAllTokens, getRefreshToken, API_HOST } from './config';

export const AppContext = createContext(null);

const logout = () => {
	const refreshToken = getRefreshToken();
	if (refreshToken) {
		fetch(`${API_HOST}auth/logout`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ refresh_token: refreshToken }),
		}).catch(() => {});
	}
	deleteAllTokens();
};

export default function UseAppContext({children}) {
	const [refetchRules, setRefetchRules] = useState(false);
	const [user, setUser] = useState(null);
	const [filter, setFilter] = useState();

	const providerValue = {
		refetchRules,
		setRefetchRules,
		user,
		setUser,
		logout,
		filter,
		setFilter
	}

	return (
		<AppContext.Provider value={providerValue}>
				{children}
		</AppContext.Provider>
  )
}
